<template>
  <div class="animated fadeIn">
    <b-card :no-body="true" class="mb-md-0">
      <b-card-body class="p-0 clearfix">
        <span :class="`bg-${variant} mr-3 float-left`">
          <i :class="`fal fa-${faIcon} p-4 font-2xl float-left`" />
        </span>
        <div class="font-scale-7 pt-2 pb-2 pr-3">
          <div class="h5 text-primary mb-0">
            <slot name="stat_value">{{ value }}</slot>
          </div>
          <div class="text-muted text-uppercase font-weight-bold">
            <slot name="stat_text">{{ text }}</slot>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "StatisticTile",
  props: ["text", "value", "faIcon", "variant"],
};
</script>
